import { LoadAccountMemberList } from '@/javascript/domain/usecases'
import { AccessDeniedError, UnexpectedError } from '@/javascript/domain/errors'
import { HttpClient, HttpStatusCode } from '../protocols/http'

export class RemoteLoadAccountMemberList implements LoadAccountMemberList {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<RemoteLoadAccountMemberList.Response>
  ) {}

  async load(searchText?: string): Promise<LoadAccountMemberList.Model[]> {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'get',
      params: {
        q: searchText
      }
    })
    const response = httpResponse.body
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return formatResponse(response)
      case HttpStatusCode.noContent: return []
      case HttpStatusCode.forbidden: throw new AccessDeniedError()
      default: throw new UnexpectedError()
    }
  }
}

export namespace RemoteLoadAccountMemberList {
  export type AccountMember = {
    id: number
    user: User
    created_at: string
    updated_at: string
  }
  type User = {
    id: number
    email: string
    complete_name_and_email: string
  }
  export type Response = {
    results?: AccountMember[]
  }
}

const formatResponse = (accountMembers: RemoteLoadAccountMemberList.Response): LoadAccountMemberList.Model[] => {
  return accountMembers?.results.map(accountMember => ({
    id: accountMember.id,
    user: {
      id: accountMember.user.id,
      completeData: accountMember.user.complete_name_and_email,
      email: accountMember.user.email
    },
    createdAt: accountMember.created_at,
    updatedAt: accountMember.updated_at,
  })) || []
}
